var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBluecheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.991,
    height: 10.403,
    viewBox: "0 0 13.991 10.403",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "done_path",
    d: "M9,16.2,5.383,12.594l-1.4,1.4L9,19l8.974-9-1.4-1.4Z",
    transform: "translate(-3.983 -8.597)",
    fill: "#00912c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBluecheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bluecheck.2fdd773548159b671c17c6b6514542d8.svg";